import { ElMessage } from "element-plus";
import axios from "axios";

//字符串转字节序列
export function stringToArrayBuffer(str: any) {
  const bytes = [];
  let len, c;
  // eslint-disable-next-line prefer-const
  len = str.length;
  for (let i = 0; i < len; i++) {
    c = str.charCodeAt(i);
    if (c >= 0x010000 && c <= 0x10ffff) {
      bytes.push(((c >> 18) & 0x07) | 0xf0);
      bytes.push(((c >> 12) & 0x3f) | 0x80);
      bytes.push(((c >> 6) & 0x3f) | 0x80);
      bytes.push((c & 0x3f) | 0x80);
    } else if (c >= 0x000800 && c <= 0x00ffff) {
      bytes.push(((c >> 12) & 0x0f) | 0xe0);
      bytes.push(((c >> 6) & 0x3f) | 0x80);
      bytes.push((c & 0x3f) | 0x80);
    } else if (c >= 0x000080 && c <= 0x0007ff) {
      bytes.push(((c >> 6) & 0x1f) | 0xc0);
      bytes.push((c & 0x3f) | 0x80);
    } else {
      bytes.push(c & 0xff);
    }
  }
  const array = new Int8Array(bytes.length);
  for (const i in bytes) {
    array[i] = bytes[i];
  }
  return array.buffer;
}

interface objInfo {
  [key: string]: any;
}
interface weekDaysType {
  [key: string]: string;
}
export const weekDays: weekDaysType = {
  "0": "日",
  "1": "一",
  "2": "二",
  "3": "三",
  "4": "四",
  "5": "五",
  "6": "六",
};

export const formatTime = (timeStr: any, fmtStr: string): string => {
  let time = timeStr;
  let fmt = fmtStr;
  try {
    if (typeof time === "string") {
      time = time.replace(/-/g, "/");
      time = new Date(time);
    }
    const o: objInfo = {
      "M+": time.getMonth() + 1, // 月份
      "d+": time.getDate(), // 日
      "h+": time.getHours(), // 小时
      "m+": time.getMinutes(), // 分
      "s+": time.getSeconds(), // 秒
      "w+": weekDays[time.getDay()],
      "q+": String(Math.floor((time.getMonth() + 3) / 3)), // 季度
      S: time.getMilliseconds(), // 毫秒
    };
    if (/(y+)/.test(fmt)) {
      const newValue = `${time.getFullYear()}`.substr(4 - RegExp.$1.length);
      fmt = fmt.replace(RegExp.$1, newValue);
    }
    for (const k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        const newValue =
          RegExp.$1.length === 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length);
        fmt = fmt.replace(RegExp.$1, newValue);
      }
    }
  } catch (e) {
    throw new Error(`${e}>>时间格式化失败>>${time}>>${fmt}`);
  }
  return fmt;
};

export function timestampToTime(time: number) {
  const date = new Date(time); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  const Y = date.getFullYear() + "-";
  const M =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1) + "-"
      : date.getMonth() + 1 + "-";
  const D =
    date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate() + " ";
  const h =
    date.getHours() < 10 ? "0" + date.getHours() + ":" : date.getHours() + ":";
  const m =
    date.getMinutes() < 10
      ? "0" + date.getMinutes() + ":"
      : date.getMinutes() + ":";
  const s =
    date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  return Y + M + D + h + m + s;
}

// 下载excel
export const handleDownLoad = async (
  url: string,
  params: any,
  customFileName: string
) => {
  const r: any = await axios.post(url, params, {
    responseType: "blob",
    headers: {
      closeDefaultMessage: true, // 不使用默认提示
    },
  });
  let filename: any = ""; //下载后文件名

  const flag = r.type === "application/json";
  if (flag) {
    // 如果异常
    const reader = new FileReader();
    reader.readAsText(r, "utf-8");
    reader.onload = function () {
      const res: any = reader.result;
      const result = JSON.parse(res); // blob格式转成json
      ElMessage.error(result.msg || "导出数据异常");
    };
  } else {
    // 正常
    if (customFileName) {
      filename = customFileName + ".xlsx"; // 下载后文件名；xlsx 为后端定义的excel文件后缀，前后需一致
    } else {
      filename = r.headers;
      filename = filename["content-disposition"];
      filename = filename.split(";")[1].split("filename=")[1];
      filename = decodeURI(filename);
    }
    const blob = new Blob([r], {
      type: "application/vnd.ms-excel",
    });
    if ("download" in document.createElement("a")) {
      // 非IE下载
      const elink = document.createElement("a");
      elink.download = filename;
      elink.style.display = "none";
      elink.href = URL.createObjectURL(blob);
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
      URL.revokeObjectURL(elink.href); // 释放URL 对象
    } else {
      // IE10+下载
      // @ts-expect-error IE10+
      navigator.msSaveBlob(blob, filename);
    }
  }
};

// 解析 excel 文件
export const getDownLoadData = async (url: string, params: any) => {
  const r: any = await axios.post(url, params, {
    responseType: "blob",
    headers: {
      closeDefaultMessage: true, // 不使用默认提示
    },
  });
  const flag = r.type === "application/json";
  if (flag) {
    // 如果异常
    const reader = new FileReader();
    reader.readAsText(r, "utf-8");
    reader.onload = function () {
      const res: any = reader.result;
      const result = JSON.parse(res); // blob格式转成json
      ElMessage.error(result.msg || "导出数据异常");
    };
  }
  const response = await r.arrayBuffer(); // 将下载的数据转成arrayBuffer格式
  return response;
};

// export function dispatchEventStroage() {
//   const signSetItem: any = localStorage.setItem;
//   localStorage.setItem = function (key, val) {
//     const setEvent: any = new Event("setItemEvent");
//     setEvent.key = key;
//     setEvent.newValue = val;
//     window.dispatchEvent(setEvent);
//     // eslint-disable-next-line prefer-rest-params
//     signSetItem.apply(this, arguments);
//   };
// }

/**
 * 时间戳生成唯一id
 * @param randomLength 随机部分的字符长度，默认 16。最终 ID = 时间戳(13位) + 随机字符
 * @returns 格式为 `{timestamp}{random}` 的唯一字符串
 */
export const generateUniqueId = (randomLength = 16): string => {
  const CHARS =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_";
  const CHARS_LEN = CHARS.length;
  const timestamp = Date.now().toString();
  const parts = new Array<string>(randomLength);
  for (let i = 0; i < randomLength; i++) {
    parts[i] = CHARS[Math.floor(Math.random() * CHARS_LEN)];
  }
  return timestamp + parts.join("");
};

export const getAjaxAddress = () => {
  let baseUrl = "";
  if (process.env.NODE_ENV === "development") {
    baseUrl = "https://zakcm-dev-tksys.in.za";
    return;
  }
  switch (process.env.VUE_APP_HOST) {
    case "prd":
      baseUrl = "https://outlet.tilchinalink.com";
      break;
    case "uat":
      baseUrl = "https://zakcm-uat-tksys.in.za";
      break;
    case "sit":
      baseUrl = "https://zakcm-sit-tksys.in.za";
      break;
    case "dev":
      baseUrl = "https://zakcm-dev-tksys.in.za";
      break;
    default:
      baseUrl = "https://outlet.tilchinalink.com";
      break;
  }
  return baseUrl;
};

export function formatNum(num: any) {
  if (isNaN(num)) {
    return num;
  }
  //1. 可能是字符串，转换为浮点数 //2. 乘以100 小数点向右移动两位 //3. Math.round 进行四舍五入 //4. 除以100 小数点向左移动两位 实现保留小数点后两位
  const value: any = Math.round(parseFloat(num) * 100) / 100;
  // 去掉小数点 存为数组
  const arrayNum = value.toString().split(".");
  // return value.toString() + ".00";
  //只有一位（整数）
  if (arrayNum.length === 1) {
    return value.toString() + ".00";
  }
  if (arrayNum.length > 1) {
    //小数点右侧 如果小于两位 则补一个0
    if (arrayNum[1].length < 2) {
      return value.toString() + "0";
    }
    return value;
  }
}
